"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CheckboxState_1 = require("./CheckboxState");
var styles = require("./Checkbox.css");
require("./../../../styles/att-icons.css");
// import '../../../styles/fonts.css';
var EventArgs_1 = require("../../../models/EventArgs");
var Checkbox = /** @class */ (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox(props) {
        var _this = _super.call(this, props) || this;
        _this.state = new CheckboxState_1.default();
        _this.onCheckboxStateChange = _this.onCheckboxStateChange.bind(_this);
        return _this;
    }
    Checkbox.prototype.componentDidMount = function () {
        this.setState({ isChecked: this.props.data.value });
    };
    Checkbox.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.data.value !== this.state.isChecked) {
            this.setState({ isChecked: nextProps.data.value });
        }
    };
    Checkbox.prototype.onCheckboxStateChange = function (event) {
        var _this = this;
        this.setState({ isChecked: event.currentTarget.checked }, function () {
            _this.props.events.onCheckboxChange(new EventArgs_1.default(_this.state.isChecked), _this.props.data && _this.props.data.text ? _this.props.data.text : '');
        });
    };
    Checkbox.prototype.getCheckBoxClasses = function () {
        var checkClasses = [
            (this.props.options.classNames ?
                (this.props.options.classNames.customCheckBox ?
                    this.props.options.classNames.customCheckBox : '') : ''),
            styles.checkbox,
            (this.props.options && this.props.options.isRennyStyle ? styles.checkboxRenny : ''),
        ];
        return checkClasses.join(' ');
    };
    Checkbox.prototype.getCheckInputClasses = function () {
        var inputClasses = [
            (this.props.options.classNames ?
                (this.props.options.classNames.customCheckboxInput ?
                    this.props.options.classNames.customCheckboxInput : '') : ''),
            styles.checkboxInput,
            (this.props.options && this.props.options.isRennyStyle ? styles.checkboxInputRenny : ''),
        ];
        return inputClasses.join(' ');
    };
    Checkbox.prototype.render = function () {
        return (React.createElement("label", { "data-test-id": this.props.testId, className: this.getCheckBoxClasses() },
            this.props && this.props.children,
            this.props && !this.props.children &&
                React.createElement("span", { "aria-hidden": "true", dangerouslySetInnerHTML: { __html: this.props.data.text } }),
            React.createElement("input", { className: this.getCheckInputClasses(), type: "checkbox", checked: this.state.isChecked, onChange: this.onCheckboxStateChange, "aria-label": this.ariaLabelContent, disabled: this.props.options.disabled }),
            React.createElement("span", { "aria-hidden": "true", className: [styles.checkmark, this.props.options.disabled ? styles.disabled : ''].join(' ') })));
    };
    Object.defineProperty(Checkbox.prototype, "ariaLabelContent", {
        get: function () {
            // ! Comma helps the sceen reader to pronouce the sentence normally.
            return (this.props.options.accessibility || '') + ", " + this.props.data.text;
        },
        enumerable: false,
        configurable: true
    });
    Checkbox.defaultProps = {
        data: {
            text: '',
            value: false,
        },
        options: {
            classNames: {
                customCheckBox: ' ',
                customCheckboxInput: ' ',
            },
        },
    };
    return Checkbox;
}(React.Component));
exports.default = Checkbox;
//# sourceMappingURL=Checkbox.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Checkbox/Checkbox.js
// module id = 1117
// module chunks = 8